module.exports = __webpack_public_path__ + "static/media/29ADMSPC5.2690be19.jpg";